import React, { useLayoutEffect, useRef, useState, useEffect } from 'react';
import axios from "axios";

import { OrgChart } from 'd3-org-chart';

import * as d3 from 'd3';

export const OrgChartComponent = (props, ref) => {

    const d3Container = useRef(null);
    let chart = null;
    var compact = 0;
    var index = 0;
    var compteur = 0;
    var compteur2 = 0;

    function swap() {
        chart.layout(["right", "top", "left", "bottom"][index++ % 4]).render().fit()
    }

    const getUserRank = async () => {     // Retourne les données de l'utilisateur   
        const userId = localStorage.getItem("userId");
        const response = await axios.get(
            `${process.env.REACT_APP_API_URL}api/auth/userRank/${userId}`
        );
    
        chart.setUpToTheRootHighlighted(response.data).render().fit()   
    };

    function myRank() {         // cible le role de l'utilisateur
        compteur++;

        if (compteur % 2 === 1) {
            getUserRank()
        } else {
            chart.clearHighlighting()
        }
    }

    function expandAll() {          // ouvre l'organigrame en entier
        compteur2++;

        if (compteur2 % 2 === 1) {
            chart.expandAll().render().fit()
        } else {
            chart.collapseAll().render().fit()
            chart.setExpanded("Spécialisations", true).render().fit()
            chart.clearHighlighting()
        }
    }



    // We need to manipulate DOM
    useLayoutEffect(() => {
        if (props.data && d3Container.current) {
            if (!chart) { chart = new OrgChart(); }

            chart
                .buttonContent(({ node, state }) => {
                    return `<div style="color:#F1F1F1;border-radius:5px;padding:3px;margin:auto auto;background-color:#1a1a1a;height: 15px;width: 15px;"> <span style="font-size:12px">${node.children
                        ? `<i class="fa-sharp fa-solid fa-angle-up"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 1024 1024"><path fill="currentColor" d="M8.2 751.4c0 8.6 3.4 17.401 10 24.001c13.2 13.2 34.8 13.2 48 0l451.8-451.8l445.2 445.2c13.2 13.2 34.8 13.2 48 0s13.2-34.8 0-48L542 251.401c-13.2-13.2-34.8-13.2-48 0l-475.8 475.8c-6.8 6.8-10 15.4-10 24.2z"/></svg></i>`
                        : `<i class="fas fa-angle-down"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 1024 1024"><path fill="currentColor" d="M8.2 275.4c0-8.6 3.4-17.401 10-24.001c13.2-13.2 34.8-13.2 48 0l451.8 451.8l445.2-445.2c13.2-13.2 34.8-13.2 48 0s13.2 34.8 0 48L542 775.399c-13.2 13.2-34.8 13.2-48 0l-475.8-475.8c-6.8-6.8-10-15.4-10-24.199z"/></svg></i>`
                        }</span> </div>`;

                })
                .linkUpdate(function (d, i, arr) {
                    d3.select(this)
                        .attr('stroke', (d) =>
                            d.data._upToTheRootHighlighted ? '#FFC107' : 'white'
                        )
                        .attr('stroke-width', (d) =>
                            d.data._upToTheRootHighlighted ? 5 : 1
                        );

                    if (d.data._upToTheRootHighlighted) {
                        d3.select(this).raise();
                    }
                })
                .nodeUpdate(function (d, i, arr) {
                    d3.select(this)
                        .select('.node-rect')
                        .attr('stroke', (d) =>
                            d.data._highlighted || d.data._upToTheRootHighlighted
                                ? '#ffd204'
                                : 'none'
                        )
                        .attr(
                            'stroke-width',
                            d.data._highlighted || d.data._upToTheRootHighlighted ? 10 : 1
                        )

                        .attr(
                            'rx',
                            d.data._highlighted || d.data._upToTheRootHighlighted ? 0 : 1
                        );

                })
                .compact(!!(compact++ % 2))
                .container(d3Container.current)
                .data(props.data)
                .nodeWidth((d) => 300)
                .nodeHeight((d) => 100)
                .onNodeClick((d, i, arr) => {
                    props.onNodeClick(d);
                })
                .nodeContent(function (d, i, arr, state) {
                    const colors = ['#278B8D', '#404040', '#0C5C73', '#33C6CB'];
                    const color = colors[d.depth % colors.length];
                    return `
           <div id ="${d.data.id}" class = "card">
           <div class = "cardContainer">
            <img class = "imageOrg" src=" ${d.data.imageUrl}"/>
           <span class = "name" ><p>${d.data.name}</p></span>
           </div>
           </div> `;
                })
                .layout(["bottom"])
                .render();
            chart.setExpanded("Spécialisations", true).render().fit()
        }
    }, [props.data, d3Container.current]);

    return (
        <div className='orgaContainer'>

            <div className='orgaContainer__button'>
                <button onClick={expandAll} >Expand</button>
                <button onClick={myRank}>Mon rang</button>
                <button onClick={swap}>Swap</button>
            </div>

            <div className='svgContainer' ref={d3Container} />
        </div>
    );
};
